import { render } from "./Holding.vue?vue&type=template&id=11f72d61&scoped=true"
import script from "./Holding.vue?vue&type=script&lang=js"
export * from "./Holding.vue?vue&type=script&lang=js"

import "./Holding.vue?vue&type=style&index=0&id=11f72d61&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11f72d61"]])

export default __exports__